export default __webpack_public_path__ + "static/media/forest.3782eca1.jpg";